import type { ErrorResponse } from 'connectors/ams';

/** The AMS public API's error envelope as a throwable, so callers can branch on `code` after `instanceof`. */
export class AmsApiError extends Error {
  readonly code: ErrorResponse['code'];

  constructor(response: ErrorResponse) {
    super(response.message);
    this.name = 'AmsApiError';
    this.code = response.code;
  }
}
